"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormAutocomplete = void 0;
const autocomplete_1 = require("../../../components/autocomplete/autocomplete");
const form_field_1 = require("./form-field");
exports.FormAutocomplete = (0, form_field_1.formFieldFactory)(autocomplete_1.Autocomplete);
//# sourceMappingURL=form-autocomplete.js.map